import { getRemoteConfig } from "firebase/remote-config";
import { app } from "./index";
import { remoteConfigInitialValues } from "@/constants/configs";

const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = import.meta.env.REMOTE_CONFIG_REFRESH_INTERVALS;
remoteConfig.defaultConfig = remoteConfigInitialValues;

export default remoteConfig;
